import {useState, useTransition} from 'react';

import {useQueryState} from 'shared/web';

import {RentalVehicleFormTabs} from '../types/RentalVehicleFormTabs';

const QUERY_TAB_KEY = 'tab';

export function useTabs() {
  const [queryTab, setQueryTab] = useQueryState(QUERY_TAB_KEY, true);
  const [isPending, startTransition] = useTransition();

  const [selectedInnerTab, setSelectedInnerTab] = useState<RentalVehicleFormTabs>(
    (queryTab || RentalVehicleFormTabs.BasicInformation) as RentalVehicleFormTabs
  );

  const setSelectedTab = (newTab: RentalVehicleFormTabs) => {
    setSelectedInnerTab(newTab);
    startTransition(() => {
      setQueryTab(newTab);
    });
  };

  return {selectedTab: selectedInnerTab, isPending, setSelectedTab};
}
